import { createFileRoute } from "@tanstack/react-router";
import { PublicHomeGateway } from "@/components/site/PublicHomeGateway";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Ground & Glass | Inside & Outside Home Cleaning" },
      { name: "description", content: "Get indicative estimates for interior and exterior home cleaning across Northern Ireland. No account needed." },
      { property: "og:title", content: "Ground & Glass | Inside & Outside Home Cleaning" },
      { property: "og:description", content: "Describe the cleaning you need, get an indicative estimate and connect with a suitable local provider." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: HomePage,
});

function HomePage() {
  return <div className="min-h-screen"><PublicHomeGateway /></div>;
}
